import {
  DealersInsightsLevelActionTypes,
  DEALERS_INSIGHTS_LEVELS,
  DEALERS_INSIGHTS_INVALID_LEVEL_ERROR_MESSAGE,
} from './constants';

function currentLevelPayloadCheck(currentLevel) {
  if (!Object.values(DEALERS_INSIGHTS_LEVELS).includes(currentLevel)) {
    throw new Error(DEALERS_INSIGHTS_INVALID_LEVEL_ERROR_MESSAGE);
  }
}

/**
 * @param {import('../../../../../shared/modules/dealersInsights/redux/level/reducer.defaultState').DealerInsightsLevel} currentLevel
 */
// used to toggle between levels while user is filtering insights
export const setDealersInsightsCurrentlyFilteredLevel = currentLevel => {
  currentLevelPayloadCheck(currentLevel);

  return {
    type: DealersInsightsLevelActionTypes.SET_LEVEL,
    currentLevel,
  };
};

// used to assign initial level depending on user authority
export const setDealersInsightsInitiallyFilteredLevel = currentLevel => {
  currentLevelPayloadCheck(currentLevel);
  return {
    type: DealersInsightsLevelActionTypes.SET_INITIAL_LEVEL,
    currentLevel,
  };
};

/**
 * @param {string} currentDealerId
 */
export const setDealersInsightsCurrentlyFilteredDealerId = currentDealerId => ({
  type: DealersInsightsLevelActionTypes.SET_DEALER_ID,
  currentDealerId,
});

/**
 * @param {string} currentDealerId
 */
export const manuallySetDealersInsightsCurrentlyFilteredDealerId = currentDealerId => ({
  type: DealersInsightsLevelActionTypes.MANUALLY_SET_DEALER_ID,
  currentDealerId,
});

export const resetDealersInsightsLevelState = () => ({
  type: DealersInsightsLevelActionTypes.RESET_STATE,
});

export const toggleDealerMenu = () => ({
  type: DealersInsightsLevelActionTypes.TOGGLE_DEALER_MENU,
});
